import { TAppState } from '../../types/appState';
import { TExperiment } from '../../types/experiments';

export const selectExperiments = (state: TAppState): TExperiment[] => state.experiments;
